var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78947 7.444C7.92982 7.572 8 7.72667 8 7.908C8 8.068 7.93567 8.20667 7.80702 8.324C7.67836 8.44133 7.52632 8.5 7.35088 8.5C7.16374 8.5 6.99415 8.42533 6.84211 8.276L4 5.316L1.17544 8.276C1.02339 8.42533 0.853801 8.5 0.666667 8.5C0.491228 8.5 0.333333 8.44133 0.192982 8.324C0.0643275 8.20667 0 8.06267 0 7.892C0 7.732 0.0701754 7.58267 0.210526 7.444L3.12281 4.452L0.333333 1.556C0.192982 1.40667 0.122807 1.25733 0.122807 1.108C0.122807 0.937333 0.187135 0.793333 0.31579 0.676C0.45614 0.558667 0.608187 0.5 0.77193 0.5C0.959064 0.5 1.12865 0.574666 1.2807 0.724L4 3.572L6.7193 0.724C6.87135 0.574666 7.04094 0.5 7.22807 0.5C7.40351 0.5 7.55556 0.558667 7.68421 0.676C7.81287 0.793333 7.87719 0.932 7.87719 1.092C7.87719 1.27333 7.80702 1.428 7.66667 1.556L4.87719 4.452L7.78947 7.444Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.0e9144ea0e09c2c4b6073d7c8aa3a5d7.svg";
export { ForwardRef as ReactComponent };